export default "__VITE_ASSET__DC_CtN8B__"